module.exports = {
	"commitCount": 1,
	"commitMembers": [
		{
			"count": 1,
			"authorName": "Bobjoy"
		}
	],
	"commitUniqueCount": 1
};


//////////////////
// WEBPACK FOOTER
// ./zh-CN/components/x-table_git_metas.json
// module id = 2562
// module chunks = 7